import type { reportFileType } from '@/features/mold/models';
import { t } from '@/i18n';
import { z } from 'zod';

export const reportType = z.enum([
  'project',
  'standard-fund',
  'local-government-fund',
  'investment-fund',
]);

export const ReportTypeLabelModifier = {
  project: t('report-type-project'),
  'standard-fund': t('report-type-standard-fund'),
  'local-government-fund': t('report-type-local-government-fund'),
  'investment-fund': t('report-type-investment-fund'),
} as const satisfies Record<z.infer<typeof reportType>, string>;

export const ReportFileTypeLabelModifier = {
  pdf: t('report-file-type-pdf'),
  csv: t('report-file-type-csv'),
} as const satisfies Record<z.infer<typeof reportFileType>, string>;
